import { isEmpty } from '@ember/utils';
import { attr } from '@ember-data/model';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import { copy } from 'ember-copy';
import moment from 'moment';
function toMoment(date) {
  return moment(date, 'YYYY-MM-DD');
}
export default EmberDataBaseFragment.extend({
  startDate: attr('string'),
  endDate: attr('string'),
  timePeriods: fragmentArray('special-hours-time-period'),
  daysOfWeek: fragmentArray('business-hours/DayOfWeek'),
  reason: attr('string'),
  isClosed: attr('boolean'),
  isNotDefined() {
    return !(this.startDate && this.endDate);
  },
  copyFrom(otherSpecialHour) {
    this.set('startDate', otherSpecialHour.startDate);
    this.set('endDate', otherSpecialHour.endDate);
    if (isEmpty(otherSpecialHour.daysOfWeek)) {
      this.set('daysOfWeek', []);
    } else {
      this.set('daysOfWeek', otherSpecialHour.daysOfWeek.map(day => copy(day)));
    }
    if (isEmpty(otherSpecialHour.timePeriods)) {
      this.set('timePeriods', []);
    } else {
      this.set('timePeriods', otherSpecialHour.timePeriods.map(period => copy(period)));
    }
    this.set('reason', otherSpecialHour.reason);
    this.set('isClosed', otherSpecialHour.isClosed);
  },
  timesToJSON() {
    const times = this.timePeriods.map(timePeriod => ({
      startTime: timePeriod.startLocalTime,
      endTime: timePeriod.endLocalTime
    }));
    return JSON.stringify(times);
  },
  doesOverlapWith(otherSpecialHour) {
    const thisStart = toMoment(this.startDate);
    const otherStart = toMoment(otherSpecialHour.startDate);
    const thisEnd = toMoment(this.endDate).add(this.hasNightCrossingPeriods() ? 1 : 0, 'days');
    const otherEnd = toMoment(otherSpecialHour.endDate).add(otherSpecialHour.hasNightCrossingPeriods() ? 1 : 0, 'days');
    return otherStart.isSameOrBefore(thisStart) && otherEnd.isSameOrAfter(thisStart) || otherStart.isSameOrAfter(thisStart) && otherStart.isSameOrBefore(thisEnd);
  },
  hasNightCrossingPeriods() {
    return this.timePeriods.any(period => period.endTimeIsNextDay());
  },
  sortTimePeriods(timePeriods = this.timePeriods) {
    const sortedTimePeriods = timePeriods.toArray().sort((a, b) => {
      const aStart = a.getLocalStartTimeMinutes();
      const bStart = b.getLocalStartTimeMinutes();
      if (aStart < bStart) {
        return -1;
      }
      if (aStart > bStart) {
        return 1;
      }
      return 0;
    });
    return sortedTimePeriods;
  },
  toMoments() {
    return {
      startMoment: toMoment(this.startDate),
      endMoment: toMoment(this.endDate)
    };
  }
}).reopenClass({
  createFromDatesAndTimesAndReason(store, startDateMoment, endDateMoment, times, reason, isClosed) {
    const startDate = startDateMoment.format('YYYY-MM-DD');
    const endDate = endDateMoment.format('YYYY-MM-DD');
    const timePeriods = times.map(time => {
      const startLocalTime = time.startLocalTime;
      const endLocalTime = time.endLocalTime;
      return store.createFragment('special-hours-time-period', {
        startLocalTime,
        endLocalTime
      });
    });
    return store.createFragment('special-hours', {
      startDate,
      endDate,
      timePeriods,
      reason,
      isClosed
    });
  },
  _modelNameForMigration: 'special-hours'
});